import { createSlice } from "@reduxjs/toolkit";

const initialState = { questions: {} };

const answeredQuestionsSlice = createSlice({
  name: "answeredQuestions",
  initialState,
  reducers: {
    setQuestion: (state, action) => {
      const { questionId } = action.payload;
      // Add the questionId as both key and value
      state.questions[questionId] = questionId;
    },
    deleteQuestion: (state, action) => {
      const questionId = String(action.payload.questionId);
      if (Object.prototype.hasOwnProperty.call(state.questions, questionId)) {
        delete state.questions[questionId];
      }
    },
    resetAnsweredQuestions: () => initialState, // Reset to the initial state
  },
});

export const { setQuestion, resetAnsweredQuestions, deleteQuestion } =
  answeredQuestionsSlice.actions;
export default answeredQuestionsSlice.reducer;
